import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "title" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/carrusel_left_arrow.svg",
    alt: "Arrow"
}, null, -1 /* HOISTED */);
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = { class: "listContent" };
const _hoisted_5 = { ref: "list" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/carrusel_right_arrow.svg",
    alt: "Arrow"
}, null, -1 /* HOISTED */);
const _hoisted_8 = [
    _hoisted_7
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("article", {
        id: "partners",
        class: _normalizeClass({ less: _ctx.schools.length < 4 })
    }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */),
        _withDirectives(_createElementVNode("div", {
            class: "arrow left",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.moveLeft && _ctx.moveLeft(...args)))
        }, _hoisted_3, 512 /* NEED_PATCH */), [
            [_vShow, _ctx.schools.length > 4]
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("figure", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schools, (school) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "partner",
                        key: school.id
                    }, [
                        _createElementVNode("img", {
                            src: school.uri,
                            alt: school.name
                        }, null, 8 /* PROPS */, _hoisted_6),
                        _createElementVNode("div", null, _toDisplayString(school.name), 1 /* TEXT */)
                    ]));
                }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */)
        ]),
        _withDirectives(_createElementVNode("div", {
            class: "arrow right",
            onClick: _cache[1] || (_cache[1] =
                //@ts-ignore
                (...args) => (_ctx.moveRight && _ctx.moveRight(...args)))
        }, _hoisted_8, 512 /* NEED_PATCH */), [
            [_vShow, _ctx.schools.length > 4]
        ])
    ], 2 /* CLASS */));
}
